import _slicedToArray from "/home/rawman/Projects/landshaft/estate/web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { createContext, useState, useContext, useMemo, isValidElement, cloneElement } from 'react';
import useConstant from 'use-constant';
var TabsState = createContext();
var Elements = createContext();

var Tabs = function Tabs(_ref) {
  var outerState = _ref.state,
      children = _ref.children;
  var innerState = useState(0);
  var elements = useConstant(function () {
    return {
      tabs: 0,
      panels: 0
    };
  });
  var state = outerState || innerState;
  return React.createElement(Elements.Provider, {
    value: elements
  }, React.createElement(TabsState.Provider, {
    value: state
  }, children));
};

var useTabState = function useTabState() {
  var _useContext = useContext(TabsState),
      _useContext2 = _slicedToArray(_useContext, 2),
      activeIndex = _useContext2[0],
      setActive = _useContext2[1];

  var elements = useContext(Elements);
  var tabIndex = useConstant(function () {
    var currentIndex = elements.tabs;
    elements.tabs += 1;
    return currentIndex;
  });
  var onClick = useConstant(function () {
    return function () {
      return setActive(tabIndex);
    };
  });
  var state = useMemo(function () {
    return {
      isActive: activeIndex === tabIndex,
      onClick: onClick
    };
  }, [activeIndex, onClick, tabIndex]);
  return state;
};

var usePanelState = function usePanelState() {
  var _useContext3 = useContext(TabsState),
      _useContext4 = _slicedToArray(_useContext3, 1),
      activeIndex = _useContext4[0];

  var elements = useContext(Elements);
  var panelIndex = useConstant(function () {
    var currentIndex = elements.panels;
    elements.panels += 1;
    return currentIndex;
  });
  return panelIndex === activeIndex;
};

var Tab = function Tab(_ref2) {
  var children = _ref2.children;
  var state = useTabState();

  if (typeof children === 'function') {
    return children(state);
  }

  return isValidElement(children) ? cloneElement(children, state) : children;
};

var Panel = function Panel(_ref3) {
  var active = _ref3.active,
      children = _ref3.children;
  var isActive = usePanelState();
  return isActive || active ? children : null;
};

export { Panel, Tab, Tabs, usePanelState, useTabState };